import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import './AboutPage.css';

export default function AboutPage() {
  const [pricePence, setPricePence] = useState(null); 

useEffect(() => {
  api.get('/courses/your-first-rental-property')
    .then(r => setPricePence(r.data?.price_pence ?? 4700))
    .catch(() => setPricePence(4700)); 
}, []);

const priceLabel = pricePence == null ? '…' : `£${(pricePence / 100).toFixed(0)}`;
  return (
    <div className="ap-page">

      {/* ── PAGE HEADER ──────────────────────────────────────────────────── */}
      <header className="ap-header">
        <div className="ap-inner">
          <h1 className="ap-header__h1">About PropertyTraining.ai</h1>
          <p className="ap-header__sub">Why we built it, and who's behind it.</p>
        </div>
      </header>

      {/* ── BODY ─────────────────────────────────────────────────────────── */}
      <main className="ap-body">
        <div className="ap-inner">

          {/* ── SECTION 1 — WHY WE BUILT THIS ─────────────────────────── */}
          <section className="ap-section">
            <h2 className="ap-section__heading">Hi, I'm Amanda.</h2>

            <p className="ap-section__body">
              Between us, my business partner Paul and I have spent 45 years buying,
              letting and managing residential property in England — mostly across
              Stoke-on-Trent, Newcastle-under-Lyme, Crewe and Birmingham. We've been
              landlords. We've been investors. We've been the managing agents people
              call when something's gone wrong with their first rental.
            </p>

            <p className="ap-section__body">
              Over the years we've seen the same thing again and again: people buying
              their first rental property without really understanding what they're getting
              into. They'd get the deposit together, find a property they liked, and run
              head-first into problems that were entirely avoidable — if only someone had
              explained the basics to them in plain English first.
            </p>

            <p className="ap-section__body">
              And the training that's out there? Most of it is a sales funnel. A free
              webinar leads to a paid weekend, and the paid weekend leads to a £5,000
              mentorship. You leave hyped up but no clearer on the actual rules — the
              legal stuff, the tax stuff, the boring stuff that protects you when something
              goes wrong.
            </p>
          </section>

          {/* ── SECTION 2 — WHAT WE BUILT INSTEAD ────────────────────── */}
          <section className="ap-section">
            {/* Pull-quote treatment for "So we built this." */}
            <p className="ap-pullquote">So we built this.</p>

            <p className="ap-section__body">
              PropertyTraining.ai is one course. {priceLabel}. Thirty lessons. Everything we
              wished someone had told us — and our clients — before they bought their
              first rental.
            </p>

            <p className="ap-section__body">
              The course is presented by Amanda AI — an AI version of me. That's how
              we keep it affordable, and how we can update lessons quickly when the law
              changes. It's also why we can offer the Ask Amanda tutor inside every
              lesson — so you can ask follow-up questions in plain English, any time, and
              get a sensible answer that reflects what's actually in the course.
            </p>

            <p className="ap-section__body">
              The content itself is grounded in our real experience. Not theory. Not US
              examples translated into Pounds. Real English property, real landlord
              obligations, real numbers from real markets we work in.
            </p>
          </section>

          {/* ── SECTION 3 — WHO'S BEHIND IT ───────────────────────────── */}
          <section className="ap-section">
            <h2 className="ap-section__heading">Who you're actually buying from</h2>

            <p className="ap-section__body">
              PropertyTraining.ai is owned and run by Essential Management Ltd, a
              company Paul Samuda and I have built together over 15 years. We're both
              based in the UK and we still actively manage property today. This isn't a
              side project or a content business — it's training built by people who do
              this for a living.
            </p>

            <p className="ap-section__body">
              If you have a question we haven't answered, you can email me directly
              on{' '}
              <a href="mailto:amanda@PropertyTraining.ai" className="ap-link">
                amanda@PropertyTraining.ai
              </a>
              . I read every message.
            </p>
          </section>

          {/* ── SECTION 4 — THE PROMISE ────────────────────────────────── */}
          <section className="ap-promise">
            <p className="ap-promise__text">
              One course. One price. No follow-up seminars. No upselling.
              Everything you need is here.
            </p>
            <p className="ap-promise__refund">
              If you decide it isn't for you, email us within 14 days and we'll refund
              you in full. No forms. No questions.
            </p>
          </section>

        </div>
      </main>

      {/* ── PRIMARY CTA ──────────────────────────────────────────────────── */}
      <section className="ap-cta">
        <div className="ap-inner ap-cta__inner">
          <Link to="/courses/your-first-rental-property" className="ap-cta__btn">
            Start the course — {priceLabel} →
          </Link>
        </div>
      </section>

    </div>
  );
}